import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import type { IVtsExhibitorHighlight } from '../types';
import styles from '../HighlightsPanel.module.scss?module';

interface HighlightTileProps {
  highlight: IVtsExhibitorHighlight;
  /** 1-based position in the grid, for the accessible name. */
  position: number;
  brand: string;
  /** Called on every turn to the back side; the panel reports only the first one. */
  onTurnToBack: (highlight: IVtsExhibitorHighlight) => void;
}

/** A highlight card: a click turns it between front and back image with a short fade. */
export default function HighlightTile({
  highlight,
  position,
  brand,
  onTurnToBack,
}: HighlightTileProps) {
  const [turned, setTurned] = useState(false);

  const handleClick = () => {
    if (!turned) {
      onTurnToBack(highlight);
    }
    setTurned(!turned);
  };

  return (
    <button
      type="button"
      className={styles.highlightTile}
      aria-pressed={turned}
      aria-label={'Highlight ' + position + ' of ' + brand + ', turn over'}
      onClick={handleClick}
    >
      <img
        className={styles.highlightFace}
        src={highlight.imageInitialLink}
        alt=""
        loading="lazy"
        data-visible={!turned}
      />
      <img
        className={styles.highlightFace}
        src={highlight.imageFlippedLink}
        alt=""
        loading="lazy"
        data-visible={turned}
      />
      <span className={styles.highlightTurn} aria-hidden="true">
        <FontAwesomeIcon icon={faRotate} />
      </span>
    </button>
  );
}
